module.exports = __webpack_public_path__ + "resources/img/img_netbackup_en.163819eea7c6c76aea43673cec956d78.png";